import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Tools|Exams Under Review|Review Tool|Exam Violations|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.ExamSecurity,
	portal: 'SP',
};

type LocNameStart = 'SPReviewToolExamVioliations';
export type SPReviewToolExamVioliationsLocNames =
	| `${LocNameStart}TitleSection`
	| `${LocNameStart}LabelDate`
	| `${LocNameStart}LabelViolation`
	| `${LocNameStart}LabelSubtype`
	| `${LocNameStart}LabelDetail`;

export const spReviewToolExamVioliationsLocs: LocDefs<SPReviewToolExamVioliationsLocNames> = {
	SPReviewToolExamVioliationsTitleSection: {
		defaultValue: 'Exam Violations',
		description: 'Section Title',
		displayPath: `${pathStart}Section Title`,
		displayType: 'Title',
		legacyName: 'Exam.Security/Tools.ExamReviewTool.Title.ExamViolationSection',
		...sharedProperties,
	},
	SPReviewToolExamVioliationsLabelDate: {
		defaultValue: 'Date',
		description: 'Column heading for: Date.',
		displayPath: `${pathStart}Date`,
		displayType: 'Label',
		legacyName: 'Exam.Security/Tools.ExamReviewTool.ColumnHeading.ViolationCreated',
		...sharedProperties,
	},
	SPReviewToolExamVioliationsLabelViolation: {
		defaultValue: 'Violation',
		description: 'Column heading for: Violation.',
		displayPath: `${pathStart}Violation`,
		displayType: 'Label',
		legacyName: 'Exam.Security/Tools.ExamReviewTool.ColumnHeading.ViolationType',
		...sharedProperties,
	},
	SPReviewToolExamVioliationsLabelSubtype: {
		defaultValue: 'Subtype',
		description: 'Column heading for: Subtype.',
		displayPath: `${pathStart}Subtype`,
		displayType: 'Label',
		legacyName: 'Exam.Security/Tools.ExamReviewTool.ColumnHeading.ViolationSubtype',
		...sharedProperties,
	},
	SPReviewToolExamVioliationsLabelDetail: {
		defaultValue: 'Detail',
		description: 'Column heading for: Detail.',
		displayPath: `${pathStart}Detail`,
		displayType: 'Label',
		legacyName: 'Exam.Security/Tools.ExamReviewTool.ColumnHeading.ViolationDetail',
		...sharedProperties,
	},
};

export type SPReviewToolExamVioliationsLocType = LocMap<SPReviewToolExamVioliationsLocNames>;
